/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const RANK_STAT_FRAGMENT = gql`
  fragment RankStat on RankStat {
    label
    value
    total
  }
`
